"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberInputValue = exports.validateNumberInput = exports.prepareNumberInputValue = exports.getNumberInputPattern = void 0;
const number_1 = require("../../utils/number");
function getNumberInputPattern(parameters, maxDigits) {
    var _a;
    return (0, number_1.getNumberRegex)(parameters.precision, true, true, true, (_a = parameters.locale) === null || _a === void 0 ? void 0 : _a.value, maxDigits, parameters.allow_zero);
}
exports.getNumberInputPattern = getNumberInputPattern;
function prepareNumberInputValue(value, locale, fieldDecimalSeparator) {
    let stringValue = (value === null || value === void 0 ? void 0 : value.toString()) || "";
    let decimalSeparator = ".";
    let negativeSeparator = "-.";
    if (locale) {
        decimalSeparator = fieldDecimalSeparator !== null && fieldDecimalSeparator !== void 0 ? fieldDecimalSeparator : (0, number_1.getDecimalSeparator)(locale);
        negativeSeparator = "-" + decimalSeparator;
        // eslint-disable-next-line prefer-regex-literals
        stringValue = stringValue.replace(new RegExp("[.|,]"), decimalSeparator);
    }
    else {
        stringValue = stringValue.replace(",", ".");
    }
    if (stringValue === null || stringValue === void 0 ? void 0 : stringValue.startsWith(negativeSeparator)) {
        stringValue = stringValue.replace(negativeSeparator, "-0" + decimalSeparator);
    }
    return stringValue;
}
exports.prepareNumberInputValue = prepareNumberInputValue;
function validateNumberInput(value, params, allowedChars) {
    return params.validator ? params.validator(value) : allowedChars.test(value);
}
exports.validateNumberInput = validateNumberInput;
function getNumberInputValue(event, regexCheckMode) {
    var _a, _b;
    if (regexCheckMode === "key") {
        return event.key;
    }
    const element = event.currentTarget;
    const value = element.value;
    const selectionStart = (_a = element.selectionStart) !== null && _a !== void 0 ? _a : 0;
    const selectionEnd = (_b = element.selectionEnd) !== null && _b !== void 0 ? _b : 0;
    const isSelectedAllText = selectionStart === 0 && selectionEnd === value.length;
    if (isSelectedAllText) {
        return event.key;
    }
    return [
        value.slice(0, selectionStart),
        event.key === "Decimal" ? "." : event.key,
        value.slice(selectionEnd),
    ].join("");
}
exports.getNumberInputValue = getNumberInputValue;
